import styled from "styled-components";

export const MobileWarning = styled.div`
  background-color: #e9f1fa;
  display: flex;
  border: 1px solid #286fad;
  border-radius: 2px;
  padding: 1rem 0.5rem 0.5rem 1rem;
  margin-bottom: 0.4rem;
`;

export const MobileIcon = styled.div`
  width: 13%;
`;

export const MobileInfo = styled.div`
  width: 87%;
`;
export const MobileText = styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  padding: 0;
  margin: 0;
  line-height: 1.2rem;
`;
export const MobileInfoTitle = styled(MobileText)`
  font-weight: bold;
`;
